export const translations = {
  pt: {
    nav: { courses: "Cursos", plans: "Planos", tools: "Ferramentas", adote: "Adote um Aluno", about: "Sobre", contact: "Contato" },
    support: "Apoie o músico",
    hero: {
      tagline: "ESCOLA DE MÚSICA · ONLINE",
      title1: "Domine seu",
      titleHi: "instrumento",
      title2: "do zero ao palco",
      desc: "Aulas de baixo, guitarra, violão, teclado e bateria com método direto ao ponto. Aprenda no seu ritmo, com prática real e acompanhamento de quem vive a música.",
      ctaPrimary: "Ver planos",
      ctaSecondary: "Conhecer os cursos",
      stat1: "Alunos ativos",
      stat2: "Aulas em vídeo",
      stat3: "Avaliação média",
    },
    courses: {
      kicker: "OS CURSOS",
      title: "Cinco instrumentos. Um método.",
      desc: "Trilhas completas com aulas práticas, exercícios e desafios semanais.",
      cta: "Quero esse curso",
      lessons: "aulas",
      level: "Do básico ao avançado",
      items: {
        baixo: { name: "Baixo", desc: "Groove, técnica de dedos, slap e teoria aplicada para segurar a banda." },
        guitarra: { name: "Guitarra", desc: "Riffs, solos, escalas e improviso com tom de verdade no amplificador." },
        violao: { name: "Violão", desc: "Ritmos, dedilhados e acompanhamento para tocar suas músicas favoritas." },
        teclado: { name: "Teclado", desc: "Acordes, harmonia, timbres e performance ao vivo com confiança." },
        bateria: { name: "Bateria", desc: "Coordenação, levadas, viradas e tempo firme como um metrônomo." },
      },
    },
    pricing: {
      kicker: "PLANOS DE LANÇAMENTO",
      title: "Comece hoje com preço de lançamento",
      desc: "Oferta por tempo limitado. Garanta acesso vitalício com desconto antes do reajuste.",
      badgePopular: "MAIS ESCOLHIDO",
      badgeLaunch: "LANÇAMENTO",
      perCourse: "pagamento único",
      buy: "Comprar agora",
      from: "de",
      off: "OFF",
      guarantee: "Garantia de 7 dias · risco zero",
      plans: {
        single: {
          name: "Curso Individual",
          tagline: "Escolha 1 instrumento",
          features: ["Acesso a 1 trilha completa", "Aulas em vídeo HD", "Exercícios e PDFs", "Acesso vitalício", "Certificado de conclusão"],
        },
        full: {
          name: "Passe Completo",
          tagline: "Todos os 5 instrumentos",
          features: ["Acesso aos 5 cursos", "Novos módulos incluídos", "Ferramentas de estudo premium", "Comunidade de alunos", "Acesso vitalício", "Certificado de conclusão"],
        },
        vip: {
          name: "Mentoria VIP",
          tagline: "Acesso total + mentoria",
          features: ["Tudo do Passe Completo", "Mentoria ao vivo mensal", "Feedback dos seus vídeos", "Suporte prioritário", "Grupo exclusivo VIP"],
        },
      },
    },
    tools: {
      kicker: "FERRAMENTAS DE ESTUDO",
      title: "Pratique direto pelo site",
      desc: "Ferramentas gratuitas para você treinar sem sair da página.",
      metronome: { name: "Metrônomo", bpm: "BPM", start: "Iniciar", stop: "Parar", beats: "Tempos" },
      tuner: { name: "Afinador de referência", desc: "Toque uma nota de referência para afinar de ouvido.", play: "Tocar nota" },
    },
    testimonials: {
      kicker: "DEPOIMENTOS",
      title: "Quem estuda, recomenda",
    },
    about: {
      kicker: "QUEM SOU",
      title: "Prazer, sou músico há mais de 15 anos",
      p1: "Comecei tocando em casa, fui parar nos palcos e em estúdios — e hoje meu objetivo é simples: encurtar o caminho que eu levei anos pra trilhar. Já acompanhei bandas, gravei discos e ensinei centenas de alunos a tirarem suas primeiras músicas.",
      p2: "Meu método é prático: nada de teoria sem som. Você pega o instrumento, toca desde a primeira aula e evolui com desafios reais. Esse texto é um exemplo — depois a gente ajusta com a sua história e troca a foto.",
      cta: "Falar comigo",
    },
    support_modal: {
      title: "Apoie o músico",
      desc: "Curtiu o conteúdo gratuito? Pague um cafezinho e ajude a manter as aulas e ferramentas no ar. 💚",
      thanks: "Valeu demais pelo apoio!",
      custom: "Outro valor",
      button: "Apoiar",
    },
    contact: {
      kicker: "CONTATO",
      title: "Vamos conversar",
      desc: "Dúvidas sobre os cursos, parcerias ou aulas particulares? Manda mensagem.",
      name: "Seu nome",
      email: "Seu e-mail",
      message: "Sua mensagem",
      send: "Enviar mensagem",
      sent: "Mensagem enviada! Em breve respondo.",
    },
    adote: {
      kicker: "INICIATIVA SOCIAL",
      title: "Adote um Aluno",
      desc: "Tem gente que sonha em aprender música mas não tem condições. Você pode apadrinhar essas aulas e mudar a história de alguém pela música.",
      steps: [
        { t: "Você apadrinha", d: "Escolhe presentear um curso ou contribuir com o valor que puder." },
        { t: "A gente conecta", d: "Selecionamos um aluno com vontade real de aprender e sem condições de pagar." },
        { t: "Ele aprende", d: "O aluno ganha acesso às aulas e você pode acompanhar a evolução dele." },
      ],
      sponsorTitle: "Quero apadrinhar",
      sponsorDesc: "Presenteie aulas pra quem sonha em tocar. Pode ser um curso inteiro ou o valor que quiser doar.",
      sponsorCta: "Apadrinhar agora",
      scholarTitle: "Preciso de uma bolsa",
      scholarDesc: "Tem vontade de aprender mas não tem como pagar agora? Conta pra gente — vamos te conectar a um padrinho.",
      scholarCta: "Pedir uma bolsa",
      impact: "Cada padrinho coloca um instrumento na mão de quem mais quer aprender. 💚",
    },
    footer: {
      tagline: "Música que se aprende tocando.",
      rights: "Todos os direitos reservados.",
      built: "Feito com",
    },
    simulated: "Pagamento simulado — integração Stripe em breve.",
    backToTop: "Voltar ao topo",
  },
  en: {
    nav: { courses: "Courses", plans: "Plans", tools: "Tools", adote: "Adopt a Student", about: "About", contact: "Contact" },
    support: "Support the musician",
    hero: {
      tagline: "MUSIC SCHOOL · ONLINE",
      title1: "Master your",
      titleHi: "instrument",
      title2: "from zero to stage",
      desc: "Bass, guitar, acoustic, keyboard and drums lessons with a straight-to-the-point method. Learn at your own pace with real practice and guidance from someone who lives music.",
      ctaPrimary: "View plans",
      ctaSecondary: "Explore courses",
      stat1: "Active students",
      stat2: "Video lessons",
      stat3: "Average rating",
    },
    courses: {
      kicker: "THE COURSES",
      title: "Five instruments. One method.",
      desc: "Complete tracks with hands-on lessons, exercises and weekly challenges.",
      cta: "I want this course",
      lessons: "lessons",
      level: "Beginner to advanced",
      items: {
        baixo: { name: "Bass", desc: "Groove, finger technique, slap and applied theory to hold the band together." },
        guitarra: { name: "Guitar", desc: "Riffs, solos, scales and improv with real tone through the amp." },
        violao: { name: "Acoustic", desc: "Rhythms, fingerpicking and accompaniment to play your favorite songs." },
        teclado: { name: "Keyboard", desc: "Chords, harmony, sounds and live performance with confidence." },
        bateria: { name: "Drums", desc: "Coordination, grooves, fills and rock-solid timing like a metronome." },
      },
    },
    pricing: {
      kicker: "LAUNCH PLANS",
      title: "Start today at launch price",
      desc: "Limited-time offer. Lock in lifetime access at a discount before the price goes up.",
      badgePopular: "MOST POPULAR",
      badgeLaunch: "LAUNCH",
      perCourse: "one-time payment",
      buy: "Buy now",
      from: "was",
      off: "OFF",
      guarantee: "7-day guarantee · zero risk",
      plans: {
        single: {
          name: "Single Course",
          tagline: "Pick 1 instrument",
          features: ["Access to 1 full track", "HD video lessons", "Exercises and PDFs", "Lifetime access", "Completion certificate"],
        },
        full: {
          name: "All-Access Pass",
          tagline: "All 5 instruments",
          features: ["Access to all 5 courses", "New modules included", "Premium study tools", "Student community", "Lifetime access", "Completion certificate"],
        },
        vip: {
          name: "VIP Mentorship",
          tagline: "Full access + mentorship",
          features: ["Everything in All-Access", "Monthly live mentorship", "Feedback on your videos", "Priority support", "Exclusive VIP group"],
        },
      },
    },
    tools: {
      kicker: "STUDY TOOLS",
      title: "Practice right on the site",
      desc: "Free tools to train without leaving the page.",
      metronome: { name: "Metronome", bpm: "BPM", start: "Start", stop: "Stop", beats: "Beats" },
      tuner: { name: "Reference tuner", desc: "Play a reference note to tune by ear.", play: "Play note" },
    },
    testimonials: {
      kicker: "TESTIMONIALS",
      title: "Students who learn, recommend",
    },
    about: {
      kicker: "WHO I AM",
      title: "Nice to meet you — a musician for 15+ years",
      p1: "I started playing at home, ended up on stages and in studios — and today my goal is simple: shorten the path that took me years to walk. I've backed bands, recorded albums and taught hundreds of students to play their first songs.",
      p2: "My method is practical: no theory without sound. You grab the instrument, play from the first lesson and grow with real challenges. This text is a placeholder — we'll adjust it with your story and swap the photo later.",
      cta: "Talk to me",
    },
    support_modal: {
      title: "Support the musician",
      desc: "Enjoying the free content? Buy a coffee and help keep the lessons and tools running. 💚",
      thanks: "Thanks so much for the support!",
      custom: "Custom amount",
      button: "Support",
    },
    contact: {
      kicker: "CONTACT",
      title: "Let's talk",
      desc: "Questions about courses, partnerships or private lessons? Send a message.",
      name: "Your name",
      email: "Your email",
      message: "Your message",
      send: "Send message",
      sent: "Message sent! I'll reply soon.",
    },
    adote: {
      kicker: "SOCIAL INITIATIVE",
      title: "Adopt a Student",
      desc: "Some people dream of learning music but can't afford it. You can sponsor their lessons and change someone's story through music.",
      steps: [
        { t: "You sponsor", d: "Choose to gift a course or contribute whatever amount you can." },
        { t: "We connect", d: "We select a student with a real will to learn who can't afford to pay." },
        { t: "They learn", d: "The student gets access to the lessons and you can follow their progress." },
      ],
      sponsorTitle: "I want to sponsor",
      sponsorDesc: "Gift lessons to someone who dreams of playing. It can be a full course or any amount you'd like to donate.",
      sponsorCta: "Sponsor now",
      scholarTitle: "I need a scholarship",
      scholarDesc: "Eager to learn but can't pay right now? Tell us — we'll connect you with a sponsor.",
      scholarCta: "Request a scholarship",
      impact: "Every sponsor puts an instrument in the hands of someone eager to learn. 💚",
    },
    footer: {
      tagline: "Music you learn by playing.",
      rights: "All rights reserved.",
      built: "Made with",
    },
    simulated: "Simulated payment — Stripe integration coming soon.",
    backToTop: "Back to top",
  },
};

export const useT = (lang) => translations[lang] || translations.pt;
